import { render, staticRenderFns } from "./BalanceCardOthers.vue?vue&type=template&id=0c9b01bb"
import script from "./BalanceCardOthers.vue?vue&type=script&lang=js"
export * from "./BalanceCardOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports